import React from "react";
import Head from 'next/head';
import PricingSection from "components/PricingSection";

function PricingPage(props) {
  const canonicalUrl = "https://www.tabextend.com/pricing";
  const pageTitle = "Pricing & Plans | tabExtend";
  const pageDescription =
    "Choose the perfect tabExtend plan for your needs. Organize your browser tabs, take notes, and boost productivity with our flexible pricing options.";
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        name: pageTitle,
        description: pageDescription,
        url: canonicalUrl
      },
      {
        "@type": "SoftwareApplication",
        name: "tabExtend",
        applicationCategory: "ProductivityApplication",
        operatingSystem: "Chrome, Edge, Brave",
        url: "https://www.tabextend.com",
        offers: [
          {
            "@type": "Offer",
            name: "Pro Monthly",
            priceCurrency: "USD",
            price: "8",
            availability: "https://schema.org/InStock",
            url: "https://www.tabextend.com/pricing"
          },
          {
            "@type": "Offer",
            name: "Pro Yearly",
            priceCurrency: "USD",
            price: "6",
            availability: "https://schema.org/InStock",
            url: "https://www.tabextend.com/pricing"
          },
          {
            "@type": "Offer",
            name: "Team Monthly",
            priceCurrency: "USD",
            price: "21",
            availability: "https://schema.org/InStock",
            url: "https://www.tabextend.com/pricing"
          },
          {
            "@type": "Offer",
            name: "Team Yearly",
            priceCurrency: "USD",
            price: "15",
            availability: "https://schema.org/InStock",
            url: "https://www.tabextend.com/pricing"
          }
        ]
      }
    ]
  };

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={canonicalUrl} />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href={canonicalUrl} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>
      <PricingSection
        color="white"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Pricing"
        subtitle="Always 30 days money back guarantee, no questions asked."
      />
    </>
  );
}

export default PricingPage;
